export const workers = (state = [], action) => {
  if (action.type === 'FETCH_WORKERS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKERS') {
    return [];
  }

  return state;
};

export const worker = (state = {}, action) => {
  if (action.type === 'FETCH_WORKER') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER') {
    return {};
  }

  return state;
};

export const workerIds = (state = [], action) => {
  if (action.type === 'FETCH_WORKER_IDS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER_IDS') {
    return [];
  }

  return state;
};

export const workerJobs = (state = [], action) => {
  if (action.type === 'FETCH_WORKER_JOBS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER_JOBS') {
    return [];
  }

  return state;
};

export const workerJob = (state = {}, action) => {
  if (action.type === 'FETCH_WORKER_JOB') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER_JOB') {
    return {};
  }

  return state;
};

export const workerIssues = (state = [], action) => {
  if (action.type === 'FETCH_WORKER_ISSUES') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER_ISSUES') {
    return [];
  }

  return state;
};

export const workerIssue = (state = {}, action) => {
  if (action.type === 'FETCH_WORKER_ISSUE') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WORKER_ISSUE') {
    return {};
  }

  return state;
};
